"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
class FlatCommission {
    constructor(currency, value, partnerId) {
        this.currency = currency;
        this.value = value;
        this.partnerId = partnerId;
        this.type = types_1.eCommissionType.FLAT_COMMISSION;
    }
    calculate(_flatRate, currency, currencyConverter) {
        if (currency === this.currency) {
            return this.value;
        }
        return currencyConverter.convert(this.currency, this.value, currency);
    }
    get isZero() {
        return this.value === 0;
    }
    get description() {
        return `Flat ${this.currency} ${this.value}`;
    }
}
exports.default = FlatCommission;
//# sourceMappingURL=flatCommission.class.js.map